import http from './axios';

export const getMenu = () => http.get('/common-menu');
